<template>
    <div
        class="fixed z-40 bg-black/30 w-full h-full flex justify-center items-center px-5 lg:px-0 text-sm lg:text-base"
        :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
    >
        <div class="w-full lg:w-fit h-auto bg-white rounded-lg flex flex-col">
            
            <!-- Header -->
            <div class="h-1/4 w-full bg-gray-300 rounded-t-lg flex justify-between items-center p-5">
                <div>{{ $t('deleteErrorTitle') }}</div>
            </div>

            <!-- Content -->
            <div class="h-3/4 w-full p-5 flex flex-col justify-center items-center rounded-b-lg space-y-5">
                <div class="w-full flex justify-center items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.75"
                        stroke="currentColor" class="w-12 text-white bg-red-400 p-1 rounded-full">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </div>

                <div class="w-2/3 text-center text-gray-600">
                    {{ $t('deleteErrorMessage') }}
                </div>
            </div>
        </div>
    </div>
</template>